export const format = (expirationDate: string): string => {
  return expirationDate.replace(/(( |)\.( |))/, ' / ');
};
